<template>
    <div class="Summary">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <h4>Team Info</h4>
                    <p><span class="bold">Name: </span><span>{{ TeamRecordData.Name }}</span></p>
                    <p><span class="bold">Program: </span><span>{{ TeamRecordData.SubProgram.Name }}</span></p>
                    <p><span class="bold">Office: </span><span>{{ TeamRecordData.Address.AddressSingleLine }} </span><GoogleMapsLink v-bind:address="TeamRecordData.Address" /></p>
                </div>
                <div class="col-md-4">
                    <h4>Team Members</h4>
                    <div v-if="CurrentTeamMembers">
                        <p><span class="bold">Supervisor: </span><span>{{ CurrentTeamMembers.Supervisor }}</span></p>
                        <p><span class="bold">Facilitator: </span><span>{{ CurrentTeamMembers.Facilitator }}</span></p>
                        <p><span class="bold">BHS: </span><span>{{ CurrentTeamMembers.BHS }}</span></p>
                        <p><span class="bold">Parent Partner: </span><span>{{ CurrentTeamMembers.PP }}</span></p>
                        <p><span class="bold">Clinician: </span><span>{{ CurrentTeamMembers.Clinician }}</span></p>
                    </div>
                </div>
                <div class="col-md-4">
                    <h4>Clients ({{ CurrentClientCount }})</h4>
                    <div v-for="client in CurrentClients">
                        <p>{{ client.ClientSubProgramMembership.Client.Person.FullName }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'TeamRecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            CurrentTeamMembers: function () {
                let output = {
                    Supervisor: "Unassigned",
                    BHS: "Unassigned",
                    Facilitator: "Unassigned",
                    PP: "Unassigned",
                    Clinician: "Unassigned"
                };
                let bhsList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Behavioral Health Specialist");
                if (bhsList.length > 0) {
                    output.BHS = bhsList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let facilitatorList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Facilitator");
                if (facilitatorList.length > 0) {
                    output.Facilitator = facilitatorList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let ppList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Parent Partner");
                if (ppList.length > 0) {
                    output.PP = ppList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let clinicianList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Clinician");
                if (clinicianList.length > 0) {
                    output.Clinician = clinicianList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let supervisorList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Supervisor");
                if (supervisorList.length > 0) {
                    output.Supervisor = supervisorList.map(e =>  e.Employee.Person.FullName).join(', ');
                }

                return output;
                
            },
            CurrentClients: function () {
                let currents = this.TeamRecordData.ClientSubProgramMemberships.filter(r => r.EndDate == null && r.ClientSubProgramMembership.EndDate == null);
                if (currents.length > 0 && currents[0].ClientSubProgramMembership.Client) {
                    return currents;
                } else {
                    return [];
                }
            },
            CurrentClientCount: function () {
                return this.TeamRecordData.ClientSubProgramMemberships.filter(r => r.EndDate == null && r.ClientSubProgramMembership.EndDate == null).length;
            }
        }
    }
</script>

<style scoped>
</style>